import customFieldsConstants from '../../constants/CustomFieldsConstants';
import { reportError } from '../../services/ErrorReporting';
import viewReadyTracker from '../../services/ViewReadyTracker';

const richTextFields = [
    customFieldsConstants.ITEM_RUBRIC_BLANK_1,
    customFieldsConstants.ITEM_RUBRIC_BLANK_2,
    customFieldsConstants.ITEM_RUBRIC_BLANK_3,
    customFieldsConstants.ITEM_RUBRIC_INTRODUCTION,
];

export const isRichTextField = (fieldName) => {
    const richTextFieldsSet = new Set(richTextFields);
    return richTextFieldsSet.has(fieldName);
};

export const fieldIsHTML = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
};

export const removeEmptyTags = (parentElement) => {
    const elements = parentElement.getElementsByTagName('*');
    for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        const innerHTML = element.innerHTML.trim().replace(/&nbsp;/g, '');
        if (innerHTML === '' && element.tagName !== 'BR') {
            element.parentNode.removeChild(element);
        }
    }
};

export const removeEmptyTagsFromHTMLString = (htmlString) => {
    if (!htmlString) {
        return htmlString;
    }
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    removeEmptyTags(doc.body);
    return doc.body.innerHTML;
};

export const addRichTextClass = (docBody) => {
    const elements = docBody.children;
    const firstElement = elements?.[0];
    const firstElementContent = firstElement?.textContent.trim().replace(/&nbsp;/g, '');
    if (firstElementContent !== '') {
        firstElement.classList.add('richText');
    }
};

export const modifyRubricsHTML = (customField) => {
    const { name, value } = customField;
    let newValue = value;
    if (Array.isArray(value)) {
        newValue = value.map((metadata) => {
            if (fieldIsHTML(metadata)) {
                const parsedHtml = new DOMParser().parseFromString(metadata, 'text/html');
                addRichTextClass(parsedHtml.body);
                removeEmptyTags(parsedHtml.body);
                return parsedHtml.body.innerHTML;
            }
            return metadata;
        });
    }
    return { name, value: newValue };
};

export const modifyCustomFields = (customFields) => {
    let modifiedCustomFields = [];
    if (customFields && Array.isArray(customFields)) {
        modifiedCustomFields = customFields.map((customField) => {
            const { name, value } = customField || {};
            if (name && value && isRichTextField(name)) {
                const customFieldWithRichText = modifyRubricsHTML(customField);
                return customFieldWithRichText;
            }
            return customField;
        });
    }

    return modifiedCustomFields;
};

export const modifyDataForRichText = (qtiContent) => {
    const { questions } = qtiContent || {};
    let modifiedQuestions = [];
    try {
        if (questions && Array.isArray(questions)) {
            modifiedQuestions = questions.map((question) => {
                const { customFields } = question;
                const modifiedCustomFields = modifyCustomFields(customFields);
                return modifiedCustomFields.length > 0 ? { ...question, customFields: modifiedCustomFields } : { ...question };
            });
        }
    } catch (error) {
        modifiedQuestions = questions;
        viewReadyTracker.logError();
        reportError(error);
    }
    return qtiContent ? { ...qtiContent, questions: modifiedQuestions.length === 0 ? questions : modifiedQuestions } : undefined;
};
